import { Link, useParams } from 'react-router-dom'
import useAuth from '../../hooks/useAuth'
import useTitle from '../../hooks/useTitle'
import { useGetProfileQuery } from '../users/usersApiSlice'
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import WelcomeTabs from './WelcomeTabs'
const Welcome = () => {
    const {groupId, type} = useParams()
    const { username, name, isTeacher, isAdmin,isStudent } = useAuth()

    const {data:user} = useGetProfileQuery("profile", {

    })

    useTitle(`geshtop-Exercise: ${username}`)

    const date = new Date()
    const today = new Intl.DateTimeFormat('en-US', { dateStyle: 'full', timeStyle: 'long' }).format(date)

    const content = (
        <>
           <p>{today}</p>


       
        <section className="welcome">
<section className='links'>
<h1>Welcome {user?.name}!</h1>
         
            <p><Link to={`/${type}/${groupId}/tasks`}>  משימות </Link></p>
            {(isStudent) && <p><Link to={`/${type}/${groupId}/my-grades`}>הצג ציונים</Link></p>}
            
            {(isStudent) && <p><Link to={`/${type}/${groupId}/my-presence`}> נוכחות</Link></p>}
            {(isStudent) && <p><Link to={`/${type}/${groupId}/my-reports`}> דוחות</Link></p>}
            {(isStudent) && <p><Link to={`/${type}/${groupId}/user-questions`}> שאלונים</Link></p>}
            {( isStudent) && <p><Link to={`/${type}/${groupId}/charts`}> גרפים</Link></p>}

            <p><Link to={`/${type}/${groupId}/final-grades`}> גליון ציונים</Link></p>

            {/* <p><Link to={`/${type}/${groupId}/actions`}>View geshtop-Exercise</Link></p>

            <p><Link to={`/${type}/${groupId}/actions/new`}>Add New techAction</Link></p> */}

            {(isTeacher || isAdmin) && <p><Link to={`/${type}/${groupId}/users`}>משתמשים</Link></p>}
            {(isTeacher || isAdmin) && <p><Link to={`/${type}/${groupId}/grades`}>ציונים</Link></p>}
            {(isTeacher || isAdmin) && <p><Link to={`/${type}/${groupId}/lessons`}>נוכחות</Link></p>}
            {(isTeacher || isAdmin) && <p><Link to={`/${type}/${groupId}/grades/multi`}> ציונים עדכון מרובה</Link></p>}


            {/* {(isTeacher || isAdmin) && <p><Link to={`/${type}/${groupId}/users/new`}>משתמש חדש</Link></p>} */}
            {(isTeacher || isAdmin) && <p><Link to={`/${type}/${groupId}/reports`}> דוחות</Link></p>}
            {(isTeacher || isAdmin) && <p><Link to={`/${type}/${groupId}/question-sets`}> שאלונים</Link></p>}
            {(isTeacher || isAdmin) && <p><Link to={`/${type}/${groupId}/question-sets/users-report`}> דוח שאלונים</Link></p>}
            {( isAdmin) && <p><Link to={`/${type}/${groupId}/companies`}> חברות</Link></p>}
            {( isAdmin) && <p><Link to={`/${type}/${groupId}/groups`}> קבוצות</Link></p>}
            {( isAdmin) && <p><Link to={`/${type}/${groupId}/courses`}> קורסים</Link></p>}
            {( isAdmin) && <p><Link to={`/${type}/${groupId}/messages`}> ניהול הודעות</Link></p>}
            {( isAdmin) && <p><Link to={`/${type}/${groupId}/task-bases`}> משימות בסיס </Link></p>}
            {( isAdmin) && <p><Link to={`/${type}/${groupId}/charts/tasks`}> גרפים</Link></p>}

            <p><Link to={`/${type}/${groupId}/profile`}> פרופיל משתמש</Link></p>
            </section>
          


        

            { <WelcomeTabs />}
          
          
          

          
       

        </section>
        </>
    )

    return content
}
export default Welcome